// Arranque de la invitación a una demo (CC-CONSOLE #1318).
//
// DEBE ser el PRIMER import de main.tsx. La liga `/register?demo=<token>` trae
// una credencial en la URL, y `initSentry()` / `initPostHog()` leen
// `window.location` en cuanto arrancan (antes de que React monte nada): el
// token saldría en el primer evento de cada uno. Importar este módulo lo
// guarda y lo quita de la barra de direcciones de forma síncrona, antes de
// que corra una sola línea de la analítica.
//
// Sólo depende de utils/demoInvite y utils/teamInvite (que no dependen de nada).
import { captureAndStripDemoToken } from "./demoInvite";
import { captureAndStripInviteToken } from "./teamInvite";

captureAndStripDemoToken();
// Mismo trato para la invitación al equipo (`/register?invite=<token>`,
// CC-CONSOLE#1512): también es una credencial en la URL.
captureAndStripInviteToken();
